<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[3].header | translate"
        [subtitle]="steps[3].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="3" />
    </div>
  </soft-page-header>

  <div class="soft-overline mt-4">
    {{'#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.SYMBOL' | translate}}
  </div>
  @if (lagersymbole$ | async; as lagersymbole) { @for (lagersymbol of lagersymbole; track
  lagersymbol; let i = $index) {
  <div class="soft-card border mt-1 p-6 rounded" (click)="onSelect(lagersymbol)">
    <div class="flex flex-row flex-nowrap">
      <div class="flex flex-col">
        <span class="text-lg font-semibold">{{lagersymbol.lagersymbol}}</span>
        <span class="color-light">{{lagersymbol.bezeichnung}}</span>
      </div>
    </div>
  </div>
  } } @if (loading$ | async) {
  <div *softRepeat="3" class="soft-card border mt-1 p-6 rounded">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex flex-col w-full">
        <div class="h-3 skeleton w-1/2"></div>
        <div class="h-3 skeleton w-full mt-2"></div>
      </div>
    </div>
  </div>
  } @if (saving$ | async) {
  <soft-blocking-loading-spinner class="top-0 right-0"></soft-blocking-loading-spinner>
  }
</soft-page>
